<template>
  <div>
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else>
      <card title="Suggestion Form">
        <div class="row">
          <div class="col">
            <fg-input
              type="text"
              required
              label="Short headline *"
              placeholder="Use geo-thermal energy for pool heating"
              v-model="form.headline"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label for="select_category" class="control-label">{{ $t('Category *') }}</label>
            <multiselect
              v-model="form.category_id"
              id="select_category"
              :options="categories.map((category) => category.id)"
              :custom-label="(opt) => categories.find((x) => x.id === opt).name"
              :loading="loading"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
          </div>
          <div class="col">
            <label for="select_subcategory" class="control-label">{{ $t('Subcategory') }}</label>
            <multiselect
              v-model="form.subcategory_id"
              :options="subcategories.map((subcategory) => subcategory.id)"
              :custom-label="(opt) => subcategories.find((x) => x.id === opt).name"
              id="select_subcategory"
              :loading="loading"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label for="select_impact" class="control-label">{{ $t('Estimated sustainability impact *') }}</label>
            <multiselect
              v-model="form.question_weight"
              :options="impactOptions.map((option) => option.value)"
              :custom-label="(opt) => impactOptions.find((option) => option.value === opt).name"
              id="select_impact"
              :loading="loading"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label>Detailed description of initiative *</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Are you using natural/organic pest control products for the buildings?"
              maxlength="500"
              v-model="form.description"
            >
            </textarea>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col">
            <label>Optional</label>
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col-8">
            <label>How would you ask for this? (max: 255)</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Are you using natural/organic pest control products for the buildings?"
              maxlength="255"
              v-model="form.question_text"
            >
            </textarea>
          </div>
          <div class="col-3">
            <label for="allow_publication" class="control-label">{{ $t('Allow Publication') }}</label>
            <fg-input
              id="allow_publication"
              type="radio"
              @checked="form.allow_publication = $event"
              :selected="
                form.allow_publication === true || form.allow_publication === 'true' || form.allow_publication === '1'
              "
            >
            </fg-input>
          </div>
        </div>
        <div class="row flex justify-content-center align-items-center">
          <div>
            <p-button type="success" :loading="loadingSave" round @click.native.prevent="submit">
              {{ $t('save') }}
            </p-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
import CategoryController from '@/controllers/Category/CategoryController';
import SubcategoryController from '@/controllers/Category/SubcategoryController';
import SuggestionController from '@/controllers/Question/SuggestionController';

export default {
  name: 'SuggestionForm',
  components: { MoonLoader },
  props: {
    loadingSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      loadingQuestions: false,
      questionTypes: [],
      questionType: null,
      form: {
        score_range: {
          max: null,
          min: null,
        },
        unit_id: null,
        allow_publication: true,
      },
      categories: [],
      subcategories: [],
      impactOptions: [
        {
          value: 1,
          name: 'Low',
        },
        {
          value: 5,
          name: 'Medium',
        },
        {
          value: 10,
          name: 'High',
        },
      ],
      units: [],
      dashForm: {},
      newDashForm: {},
    };
  },
  async beforeMount() {
    this.setLoading();
    await this.setForm();

    this.setCompany();

    Promise.all([this.getQuestionTypes(), this.getCategories(), this.getSubcategories()]).then((response) => {
      this.questionTypes = response[0];
      this.categories = response[1];
      this.subcategories = response[2];

      this.setQuestionType();
      this.resetLoading();
    });
  },
  methods: {
    setLoading() {
      this.loading = true;
    },
    resetLoading() {
      this.loading = false;
    },
    getQuestionTypes() {
      return QuestionTypeController.index();
    },
    setQuestionType() {
      this.questionType = this.questionTypes.find((type) => {
        return type.name === 'Initiative';
      });
    },
    submit() {
      let newForm = this.form;
      if (typeof this.form.score_range == null) delete newForm.score_range;
      if (typeof this.form.unit_id == null) delete newForm.unit_id;
      newForm.question_type_id = this.questionType.id;
      this.$emit('submit', newForm);
    },
    async setForm() {
      if (this.$route.params.suggestionId) {
        const { data } = await SuggestionController.show(this.$route.params.suggestionId);
        this.form = {
          ...this.form,
          ...data,
          headline: data.dashboard_element.headline,
        };
      }
    },
    setCompany() {
      this.company = this.$store.getters.company;
    },
    getCategories() {
      return CategoryController.index();
    },
    getSubcategories() {
      return SubcategoryController.index();
    },
  },
};
</script>
